import {useGetData} from '../../src/apiservice/apiCall'


export function useInformation(){
	return useGetData('/api/WebApi/GetInformation')
}
